import { Loading } from '@autopass-web/mochi-component';

const Processing = () => {
  return <div className="flex flex-col items-center justify-center text-[#999999] bg-[#F7F7F7] h-screen">
      <Loading inline />
      <div>交易處理中，請稍候</div>
      <div className="text-[14px] mt-1.5 w-[70%] text-center">
        為了確保交易成功，請勿重新整理或關閉頁面。
      </div>
    </div>
}

export { Processing }